export default "__VITE_ASSET__aa9b5073__"